import { ResourceDto } from '@bom-nextgen-keycloak/models';
import { ResourceApplication } from '@bom-nextgen-keycloak/web/shared/data-access';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { RootState } from '../store';

export interface ResourceState {
  optionResource: ResourceApplication[];
  selectResource: ResourceApplication;
}

const initialState: ResourceState = {
  optionResource: [],
  selectResource: {
    resourceId: '',
    resourceName: '',
    displayName: '',
    clientId: '',
    clientName: '',
    clientNamePublic: '',
    groupId: '',
    scopes: [],
  },
};

export const mapResourceApplication = (
  data: ResourceDto[]
): ResourceApplication[] => {
  return data.map((val) => ({
    resourceId: val._id || uuidv4(),
    resourceName: val.name || '',
    displayName: val?.displayName || 'Default Name',
    clientId: val?.attributes?.client_id ? val?.attributes?.client_id[0] : '',
    clientName: val?.attributes?.client_name
      ? val?.attributes?.client_name[0]
      : '',
    clientNamePublic: val?.attributes?.client_name_public
      ? val?.attributes?.client_name_public[0]
      : '',
    groupId: val?.attributes?.group_id ? val?.attributes?.group_id[0] : '',
    scopes: val.scopes || [],
  }));
};

export const mapdefaultResourceApplication = (
  resources: ResourceDto
): ResourceApplication => {
  return {
    resourceId: resources?._id || '',
    resourceName: resources?.name || '',
    displayName: resources?.displayName || 'Default Name',
    clientId: resources?.attributes?.client_id
      ? resources?.attributes?.client_id[0]
      : '',
    clientName: resources?.attributes?.client_name
      ? resources?.attributes?.client_name[0]
      : '',
    clientNamePublic: resources?.attributes?.client_name_public
      ? resources?.attributes?.client_name_public[0]
      : '',
    groupId: resources?.attributes?.group_id
      ? resources?.attributes?.group_id[0]
      : '',
  };
};

const getDefaultPermissions = (persmission: ResourceDto[]) => {
  const resource: ResourceApplication = localStorage.getItem('resource')
    ? JSON.parse(localStorage.getItem('resource') || '')
    : null;
  const find = persmission.find((val) => val._id === resource?.resourceId);
  if (find) {
    return resource;
  }
  return mapdefaultResourceApplication(persmission[0]);
};

export const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    setResource: (state, action: PayloadAction<ResourceDto[]>) => {
      state.optionResource = mapResourceApplication(action.payload);
      state.selectResource = getDefaultPermissions(action.payload);
    },
    setSelectedResource: (
      state,
      action: PayloadAction<ResourceApplication>
    ) => {
      state.selectResource = action.payload;
    },
  },
});

export const { setResource, setSelectedResource } = resourceSlice.actions;

export const selectResource = (state: RootState) =>
  state.resource.selectResource;
export const selectOptionResource = (state: RootState) =>
  state.resource.optionResource;

export default resourceSlice.reducer;
